import { config } from '../config';
import { getHeaders } from './getHeaders';

export const getRooferSession = (email: string, password: string) =>
  fetch(`${config.apiBaseUrl}/api/v1/roofer/session`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({ email, password }),
  });
